import { forwardRef, ForwardedRef, ForwardRefRenderFunction } from 'react';

import { Button, Card, Text } from '@hh.ru/magritte-ui';
import { HeartFilledSize16, HeartOutlinedSize16 } from '@hh.ru/magritte-ui/icon';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';

const TrlKeys = {
    save: 'resume.card.action.favorites.save',
    saved: 'resume.card.action.favorites.saved',
    menuSave: 'resume.card.action.favorites.menu.save',
    menuSaved: 'resume.card.action.favorites.menu.saved',
};

interface FavoritesButtonProps {
    isSaved: boolean;
    isMobile?: boolean;
    onClick: () => void;
    fwdRef?: ForwardedRef<HTMLButtonElement>;
    closeAdditionalMenu?: () => void;
}

const FavoritesButtonRaw: TranslatedComponent<FavoritesButtonProps> = ({
    isSaved,
    isMobile,
    onClick,
    trls,
    fwdRef,
    closeAdditionalMenu,
}) => {
    if (closeAdditionalMenu) {
        return (
            <Card
                onClick={onClick}
                borderRadius={16}
                padding={12}
                paddingLeft={16}
                hoverStyle="secondary"
                stretched
                data-qa={`resume-serp__resume-mark-favorite-${String(isSaved)}`}
            >
                <Text style="primary" typography="label-2-regular">
                    {trls[isSaved ? TrlKeys.menuSaved : TrlKeys.menuSave]}
                </Text>
            </Card>
        );
    }

    const buttonText = trls[isSaved ? TrlKeys.saved : TrlKeys.save];

    return (
        <Button
            stretched={isMobile}
            size="small"
            mode="secondary"
            icon={isSaved ? <HeartFilledSize16 initialColor="negative" /> : <HeartOutlinedSize16 />}
            onClick={onClick}
            aria-label={buttonText}
            data-qa={`resume-serp__resume-mark-favorite-${String(isSaved)}`}
            ref={fwdRef}
        >
            {isMobile && buttonText}
        </Button>
    );
};

const Translated = translation(FavoritesButtonRaw);
const FavoritesButton: ForwardRefRenderFunction<HTMLButtonElement, FavoritesButtonProps> = (props, ref) => (
    <Translated {...props} fwdRef={ref} />
);

export default forwardRef(FavoritesButton);
